import {computeChecks} from "./MatchChecksDashboard.tsx";
import {MatchChecksDashboard} from "../../../../../components/matches/MatchChecks.tsx";
import {reconciliationRuleTranslations} from "./ReconciliationRuleTranslations.tsx";
import AIToolTip from "../../../../../components/general/AIToolTip.tsx";
import {TransactionInfo} from "./TransactionInfo.tsx";
import {DocumentInfo} from "./DocumentInfo.tsx";
import {SecondaryButton} from "../../../../../components/general/SecondaryButton.tsx";
import Popup from "../../../../../components/general/Popup.tsx";
import * as React from "react";
import {useState} from "react";

export function Match({match, businessId, onOpenDocument, onUnmatch}: {
    match: any,
    businessId: string,
    onOpenDocument: (businessId: string, documentId: string) => void,
    onUnmatch?: (matchId: string, transactionIds: string[], billIds: string[]) => void
}) {
    const [isUnmatchPopupOpen, setIsUnmatchPopupOpen] = useState(false);
    const checks = computeChecks(match);

    const translatedRule = reconciliationRuleTranslations[match.match_description] || match.match_description;

    const handleDocumentClick = () => {
        if (businessId && match.document.document_id) {
            onOpenDocument(businessId, match.document.document_id);
        }
    };

    const handleUnmatchClick = () => {
        setIsUnmatchPopupOpen(true);
    };

    const handleUnmatchConfirm = () => {
        if (onUnmatch && match.match_id && match.transaction_ids && match.bill_ids) {
            onUnmatch(match.match_id, match.transaction_ids, match.bill_ids);
        }
        setIsUnmatchPopupOpen(false);
    };

    return (
        <div className="bg-white shadow-sm border border-gray-200 rounded-lg p-6 mb-6 relative">
            <div className="flex justify-between items-start mb-4">
                <h3 className="text-lg font-semibold text-gray-800">{match.match_title}</h3>
                {onUnmatch && (
                    <SecondaryButton
                        title="Ontkoppelen"
                        onClick={handleUnmatchClick}
                    />
                )}
            </div>
            <div className="flex my-1">
                <div className="pl-2 pr-3 py-1.5 flex gap-2 items-center border border-gray-200 rounded-full">

                    <AIToolTip text={"Matched using Transaction Intelligence"}/>


                    <p className="text-sm text-black">{translatedRule}</p>
                </div>
            </div>


            <div className="my-4">
                <MatchChecksDashboard checks={checks}/>
            </div>
            <div className="flex">
                <TransactionInfo data={match.transaction}/>
                <DocumentInfo
                    data={match.document}
                    onClick={handleDocumentClick}
                />
            </div>
            
            <Popup
                open={isUnmatchPopupOpen}
                onClose={() => setIsUnmatchPopupOpen(false)}
                onConfirm={handleUnmatchConfirm}
                title="Match ontkoppelen"
                variant="danger"
                confirmButtonDisplayLabel="Ontkoppelen"
            >
                <p className="text-sm text-gray-500">
                    Weet u zeker dat u deze match wilt ontkoppelen? Deze actie kan niet ongedaan worden gemaakt.
                </p>
            </Popup>
        </div>
    );
}
